module.exports = __webpack_public_path__ + "img/24chboxon.1cf6d594.svg";